/**
 * True while the Node prerender pass (scripts/prerender.js) is driving the page.
 *
 * v60.102.9 — widgets that are deliberately random or time-based must freeze
 * on their seed state during prerendering. Otherwise the HTML we bake shows
 * one set of values, the browser's first paint computes another, and React
 * throws hydration error #418 — which logged a console exception on every
 * page (Lighthouse Best Practices stuck at 96 sitewide) and forced React to
 * throw away the prerendered tree and re-render client-side, inflating mobile
 * LCP to roughly 4 s on pages that first-paint in under half a second.
 */
export const isPrerendering = () =>
  typeof window !== "undefined" && window.__FP_PRERENDER__ === true;
